export default {
    isGeoLocationSupported(){
        if(!("geolocation" in navigator)) {
            return false;
        }else{
            return true;
        }
    },

    async getCurrentGeoLocation(){
        return new Promise((resolve, reject)=>{
            if(!this.isGeoLocationSupported){
                reject(new Error('LOCATION-NOT-AVAILABLE'));
            }

            navigator.geolocation.getCurrentPosition(pos =>{
                resolve(pos);
            },err =>{
                reject(err);
            })
        });
    }
}